import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo-design-f-01.svg'


const _withScopeId = n => (_pushScopeId("data-v-3bc032f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gradient-to-b from-zinc-200 via-zinc-300 border-indigo-400 to-zinc-500 border-b fixed w-full z-50" }
const _hoisted_2 = {
  class: "mx-auto bg-transparent flex max-w-full items-center justify-between gap-x-6 p-6 lg:px-8",
  "aria-label": "Global"
}
const _hoisted_3 = { class: "flex w-full justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"w-1/3 flex justify-start\" data-v-3bc032f1><a href=\"/\" class=\"flex flex-row items-center justify-center m-1 p-1 sm:-m-1.5 sm:p-1.5\" data-v-3bc032f1><span class=\"sr-only\" data-v-3bc032f1>fleetup design</span><img class=\"h-5 w-auto sm:h-10\" src=\"" + _imports_0 + "\" alt=\"\" data-v-3bc032f1><p class=\"pl-2 text-2xl text-sky-600 font-bold sm:pl-4 sm:text-4xl\" data-v-3bc032f1>fleetup</p><h2 class=\"text-sm sm:text-xsm text-sky-500\" data-v-3bc032f1>design</h2></a></div>", 1)
const _hoisted_5 = { class: "w-1/3 flex justify-center" }
const _hoisted_6 = { class: "hidden lg:flex lg:gap-x-12" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline absolute left-0 bottom-0 h-1 w-full bg-indigo-600 transform scale-x-0 group-hover:scale-x-100 transition-transform" }, null, -1))
const _hoisted_9 = { class: "w-1/3 flex justify-end" }
const _hoisted_10 = { class: "flex flex-1 items-center justify-end gap-x-6" }
const _hoisted_11 = {
  key: 0,
  class: "relative flex items-center gap-x-4"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "flex gap-x-2 lg:flex hidden"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/login",
  class: "lg:block lg:text-lg lg:font-semibold lg:leading-6 lg:text-gray-600 border border-gray-600 px-3 py-2 rounded transition duration-200 hover:bg-gray-600 hover:text-white"
}, "Log in", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/SignUp",
  class: "lg:block lg:text-lg lg:font-semibold lg:leading-6 lg:text-gray-600 border border-gray-600 px-3 py-2 rounded transition duration-200 hover:bg-gray-600 hover:text-white"
}, "Sign up", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "flex lg:hidden" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 z-10" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close menu", -1))
const _hoisted_24 = { class: "mt-10 flow-root mt-40" }
const _hoisted_25 = { class: "-my-6 divide-y divide-gray-500/10" }
const _hoisted_26 = { class: "space-y-2 py-6" }
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
  }, "Log in"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/SignUp",
    class: "-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
  }, "Sign up")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navigation, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name,
                class: "group relative"
              }, [
                _createElementVNode("a", {
                  href: item.href,
                  class: "text-sm font-semibold leading-6 text-gray-800"
                }, _toDisplayString(item.name), 9, _hoisted_7),
                _hoisted_8
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            ($setup.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.showDropdown = !$setup.showDropdown), ["stop"])),
                    class: "inline-block h-12 w-12 overflow-hidden rounded-full bg-gray-100 cursor-pointer"
                  }, [
                    ($setup.userProfilePic)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.userProfilePic,
                          class: "h-full w-full object-cover",
                          alt: "User Avatar"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15))
                  ]),
                  ($setup.showDropdown)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                        class: "absolute right-0 mt-48 w-40 bg-white border border-gray-300 rounded-lg shadow-lg",
                        ref: "dropdownMenuRef"
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.signOut && $setup.signOut(...args))),
                          class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        }, "Logout")
                      ], 512))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("button", {
          type: "button",
          class: "-m-2.5 mr-8 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mobileMenuOpen = true))
        }, [
          _hoisted_21,
          _createVNode(_component_Bars3Icon, {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ], 512), [
          [_vShow, !$setup.mobileMenuOpen]
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      as: "div",
      class: "lg:hidden",
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.mobileMenuOpen = false)),
      open: $setup.mobileMenuOpen
    }, {
      default: _withCtx(() => [
        _hoisted_22,
        _createVNode(_component_DialogPanel, { class: "fixed inset-y-0 right-0 z-10 w-6xl overflow-y-auto bg-indigo-300 border-l-indigo-500/50 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10" }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "absolute top-4 right-0 m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.mobileMenuOpen = false))
            }, [
              _hoisted_23,
              _createVNode(_component_XMarkIcon, {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navigation, (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: item.name,
                      href: item.href,
                      class: "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    }, _toDisplayString(item.name), 9, _hoisted_27))
                  }), 128))
                ]),
                _hoisted_28
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}